import { useLocation } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import AppTopBar from './AppTopBar';

const pageTitles: Record<string, string> = {
  '/': '智能工作區',
  '/chat': '智能工作區',
  '/knowledge-base': '知識庫管理',
  '/knowledge-base/create': '建立新知識庫',
  '/admin': '使用者管理',
  '/export': '資料匯出'
};

function getTitle(pathname: string): string {
  if (pageTitles[pathname]) return pageTitles[pathname];
  if (pathname.startsWith('/knowledge-base/')) return '知識庫詳情';
  return 'EdgeMindAI';
}

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  const title = getTitle(location.pathname);

  return (
    <div className="flex h-screen overflow-hidden">
      <AppSidebar />
      <div className="flex flex-col flex-1 min-w-0">
        <AppTopBar title={title} />
        <main className="flex-1 overflow-auto bg-secondary custom-scrollbar">{children}</main>
      </div>
    </div>
  );
}
